import React from "react";

import PublicIcon from "../icons/Public";
import ConfidentialIcon from "../icons/Confidential";
import HighlyConfidentialIcon from "../icons/HighlyConfidential";
import InternalUseIcon from "../icons/InternalUse";

const icons = {
  0: { icon: <PublicIcon />, label: "Public" },
  1: { icon: <InternalUseIcon />, label: "Internal Use" },
  2: { icon: <ConfidentialIcon />, label: "Confidential" },
  3: { icon: <HighlyConfidentialIcon />, label: "Highly Confidential" },
};

export default icons;
